export default function FormControl({ className, children }) {
    const extraClass = className ? ` ${className}` : ''

    return (
        <div className={`form-control w-full${extraClass}`}>
            {children}
        </div>
    );
}
